import axios from 'axios'; 
 
const service = axios.create({
     
    // process.env.NODE_ENV === 'development' 来判断是否开发环境
    // easy-mock服务挂了，暂时不使用了
    baseURL: process.env.VUE_APP_BASE_URL,
    timeout: 10000,
    headers:{
        'Cache-Control': 'no-cache' //重点清除接口的缓存  
    } 
});

service.interceptors.request.use(
    config => {
        // 1.从缓存中获取到token,这里的Authorization时登录时你给用户设置token的键值
        let authorization = localStorage.getItem(window.location.hostname+'_token');  
        // 2.如果token不为null，那么设置到请求头中，此处哪怕为null，我们也不进行处理，因为后台会进行拦截
        if (authorization) {
        //后台给登录用户设置的token的键时什么，headers['''']里的键也应该保持一致
            config.headers['Authorization'] = authorization;
        } 
        // 3.放行
        return config;
    },
    error => {
        console.log(error);
        return Promise.reject();
    }
);

service.interceptors.response.use(
    response => {
        if (response.status === 200) {
            return response.data;
        } else {
            Promise.reject();
        }
    },
    error => {
        console.log(error);
        return Promise.reject();
    }
);

export default service;
